import { CommonModule } from '@angular/common';
import {
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { IfaaUiComponentsModule } from '@ifaa-components/ui-components';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { TranslateModule } from '@ngx-translate/core';
import { NgApexchartsModule } from 'ng-apexcharts';
import { NgCircleProgressModule } from 'ng-circle-progress';
import { PdfJsViewerModule } from 'ng2-pdfjs-viewer';
import { NgrxFormsModule } from 'ngrx-forms';
import { MaterialModule } from 'src/app/app.material.module';
import { AccessYourSuperBankDetailsComponentEffects } from './components/access-your-super-bank-details/effects';
import { AccessYourSuperCeasedPaidEmploymentComponentEffects } from './components/access-your-super-custom-sections/access-your-super-ceased-paid-employment/effects';
import { AccessYourSuperCeasedWorkSixtyComponentEffects } from './components/access-your-super-custom-sections/access-your-super-ceased-work-sixty/effects';
import { AccessYourSuperCompassionateGroundsComponentEffects } from './components/access-your-super-custom-sections/access-your-super-compassionate-grounds/effects';
import { AccessYourSuperKiwiSaverComponentEffects } from './components/access-your-super-custom-sections/access-your-super-kiwi-saver/effects';
import { AccessYourSuperPensionCommutationsComponentEffects } from './components/access-your-super-custom-sections/access-your-super-pension-commutations/effects';
import { AccessYourSuperPermanentRetirementPreservationComponentEffects } from './components/access-your-super-custom-sections/access-your-super-permanent-retirement-preservation/effects';
import { AccessYourSuperRetirementComponentEffects } from './components/access-your-super-custom-sections/access-your-super-retirement/effects';
import { AccessYourSuperSevereFinancialHardshipComponentEffects } from './components/access-your-super-custom-sections/access-your-super-severe-financial-hardship/effects';
import { AccessYourSuperTerminalMedicalConditionComponentEffects } from './components/access-your-super-custom-sections/access-your-super-terminal-medical-condition/effects';
import { AccessYourSuperUnrestrictedNonPreservedComponentEffects } from './components/access-your-super-custom-sections/access-your-super-unrestricted-non-preserved/effects';
import { AccessYourSuperDocumentsComponentEffects } from './components/access-your-super-documents/effects';
import { AccessYourSuperFormComponentEffects } from './components/access-your-super-form/effects';
import { AccessYourSuperLastEmployerComponentEffects } from './components/access-your-super-last-employer/effects';
import { AccessYourSuperReviewComponentEffects } from './components/access-your-super-review/effects';
import { AccessYourSuperStartComponentEffects } from './components/access-your-super-start/effects';
import { AccessYourSuperTypeSelectionComponentEffects } from './components/access-your-super-type-selection/effects';
import { AccessYourSuperUpdateSubmittedComponentEffects } from './components/access-your-super-update-submitted/effects';
import { AccountFeesEffects } from './components/account-fees/effects';
import { AccountSummaryEffects } from './components/account-summary/effects';
import { AccountUnderlyingInvestmentSummaryViewEffects } from './components/account-underlying-investment-summary-view/effects';
import { AccountUnderlyingViewEffects } from './components/account-underlying-view/effects';
import { BeneficiariesEditEffects } from './components/beneficiaries-edit/effects';
import { BeneficiariesViewEffects } from './components/beneficiaries-view/effects';
import { BPAYDetailsEffects } from './components/bpay-details/effects';
import { CashTransactionsEffects } from './components/cash-transactions/effects';
import { ChatViewEffects } from './components/chat/effects';
import { ConsolidateSuperEffects } from './components/consolidate-super/effects';
import { ContributionsLimitsEffects } from './components/contributions-limits/effects';
import { DocumentViewerEffects } from './components/document-viewer/effects';
import { HistoricalChartViewEffects } from './components/historical-chart/effects';
import { InsuranceDetailsEffects } from './components/insurance-details/effects';
import { InsuranceQuestionnaireEffects } from './components/insurance-questionnaire/effects';
import { InsuranceQuestionnaireStartEffects } from './components/insurance-questionnaire-start/effects';
import { InsuranceUpdateHistoryComponentEffects } from './components/insurance-update-history/effects';
import { InsuranceUpdateComponentEffects } from './components/insurance-update/effects';
import { EditInvestmentEffects } from './components/investment-edit/effects';
import { InvestmentOptionsEffects } from './components/investment-options/effects';
import { InvestmentSwitchHistoryEffects } from './components/investment-switch-history/effects';
import { MemberAccountDropdownEffects } from './components/member-account-dropdown/effects';
import { MemberAlertViewEffects } from './components/member-alert/effects';
import { EditMemberEffects } from './components/member-edit/effects';
import { MemberPensionEffects } from './components/member-pension-view/effects';
import { MemberViewOverviewEffects } from './components/member-view-overview/effects';
import { MemberEffects } from './components/member-view/effects';
import { NoticeOfIntentTaxDeductionContainerComponentEffects } from './components/notice-of-intent-tax-deduction-container/effects';
import { NoticeOfIntentTaxDeductionFormComponentEffects } from './components/notice-of-intent-tax-deduction-form/effects';
import { NotificationDropdownEffects } from './components/notification-dropdown/effects';
import { PensionChangePaymentScheduleRequestsEffects } from './components/pension-change-schedule-requests/effects';
import { PensionChangePaymentScheduleEffects } from './components/pension-change-schedule/effects';
import { PersonalContributionEditEffects } from './components/personal-contribution-edit/effects';
import { RecentEmploymentDetailsEffects } from './components/recent-employment-details/effects';
import { RollInEditEffects } from './components/rollin-edit/effects';
import { StartAPensionFormComponentEffects } from './components/start-a-pension/start-a-pension-form/effects';
import { StartAPensionAccountDetailsFormComponentEffects } from './components/start-a-pension/start-a-pension-form/start-a-pension-account-details-form/effects';
import { StartAPensionBankDetailsFormComponentEffects } from './components/start-a-pension/start-a-pension-form/start-a-pension-bank-details-form/effects';
import { StartAPensionBeneficiaryFormComponentEffects } from './components/start-a-pension/start-a-pension-form/start-a-pension-beneficiary-form/effects';
import { StartAPensionDocumentsFormComponentEffects } from './components/start-a-pension/start-a-pension-form/start-a-pension-documents-form/effects';
import { StartAPensionEligibilityFormComponentEffects } from './components/start-a-pension/start-a-pension-form/start-a-pension-eligibility-form/effects';
import { StartAPensionPaymentDetailsFormComponentEffects } from './components/start-a-pension/start-a-pension-form/start-a-pension-payment-details-form/effects';
import { StartAPensionReviewComponentEffects } from './components/start-a-pension/start-a-pension-form/start-a-pension-review/effects';
import { StartAPensionStartComponentEffects } from './components/start-a-pension/start-a-pension-start/effects';
import { StartAPensionUpdateSubmittedComponentEffects } from './components/start-a-pension/start-a-pension-update-submitted/effects';
import { SuperannuationProviderSearchEffects } from './components/superannuation-provider-search/effects';
import { SwitchInvestmentsEffects } from './components/switch-investments-edit/effects';
import { UnitPricesViewEffects } from './components/unit-prices-view/effects';
import { MemberPortalSharedRoutingModule } from './shared-routing.module';
import {
  featureKey,
  reducers,
  localStorageSyncMetaReducer,
} from './store/shared.reducers';

@NgModule({
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [
    CommonModule,
    NgApexchartsModule,
    PdfJsViewerModule,
    IfaaUiComponentsModule,
    MemberPortalSharedRoutingModule,
    MaterialModule,
    NgrxFormsModule,
    ReactiveFormsModule,
    StoreModule.forFeature(featureKey, reducers, {
      metaReducers: [localStorageSyncMetaReducer],
    }),
    EffectsModule.forFeature([
      MemberEffects,
      MemberViewOverviewEffects,
      AccountUnderlyingViewEffects,
      AccountUnderlyingInvestmentSummaryViewEffects,
      BeneficiariesViewEffects,
      BPAYDetailsEffects,
      EditMemberEffects,
      EditInvestmentEffects,
      BeneficiariesEditEffects,
      CashTransactionsEffects,
      MemberAccountDropdownEffects,
      HistoricalChartViewEffects,
      InsuranceQuestionnaireStartEffects,
      InsuranceQuestionnaireEffects,
      InvestmentOptionsEffects,
      InsuranceDetailsEffects,
      SwitchInvestmentsEffects,
      RollInEditEffects,
      ContributionsLimitsEffects,
      SuperannuationProviderSearchEffects,
      PersonalContributionEditEffects,
      ConsolidateSuperEffects,
      UnitPricesViewEffects,
      DocumentViewerEffects,
      NotificationDropdownEffects,
      MemberPensionEffects,
      AccessYourSuperStartComponentEffects,
      AccessYourSuperTypeSelectionComponentEffects,
      AccessYourSuperFormComponentEffects,
      AccessYourSuperLastEmployerComponentEffects,
      AccessYourSuperBankDetailsComponentEffects,
      AccessYourSuperDocumentsComponentEffects,
      AccessYourSuperRetirementComponentEffects,
      AccessYourSuperCeasedWorkSixtyComponentEffects,
      AccessYourSuperPermanentRetirementPreservationComponentEffects,
      AccessYourSuperCeasedPaidEmploymentComponentEffects,
      AccessYourSuperPensionCommutationsComponentEffects,
      AccessYourSuperReviewComponentEffects,
      RecentEmploymentDetailsEffects,
      AccountSummaryEffects,
      AccessYourSuperTerminalMedicalConditionComponentEffects,
      AccessYourSuperSevereFinancialHardshipComponentEffects,
      AccessYourSuperCompassionateGroundsComponentEffects,
      AccessYourSuperUnrestrictedNonPreservedComponentEffects,
      AccessYourSuperKiwiSaverComponentEffects,
      ChatViewEffects,
      AccessYourSuperUpdateSubmittedComponentEffects,
      NoticeOfIntentTaxDeductionContainerComponentEffects,
      NoticeOfIntentTaxDeductionFormComponentEffects,
      MemberAlertViewEffects,
      AccountFeesEffects,
      PensionChangePaymentScheduleEffects,
      PensionChangePaymentScheduleRequestsEffects,
      InvestmentSwitchHistoryEffects,
      StartAPensionStartComponentEffects,
      StartAPensionFormComponentEffects,
      StartAPensionEligibilityFormComponentEffects,
      StartAPensionAccountDetailsFormComponentEffects,
      StartAPensionPaymentDetailsFormComponentEffects,
      StartAPensionBankDetailsFormComponentEffects,
      StartAPensionBeneficiaryFormComponentEffects,
      StartAPensionDocumentsFormComponentEffects,
      StartAPensionReviewComponentEffects,
      StartAPensionUpdateSubmittedComponentEffects,
      InsuranceUpdateComponentEffects,
      InsuranceUpdateHistoryComponentEffects,
    ]),
    TranslateModule.forChild(),
    NgCircleProgressModule.forRoot({
      radius: 100,
      outerStrokeWidth: 16,
      innerStrokeWidth: 8,
      animationDuration: 400,
      backgroundPadding: 0,
      animation: true,
    }),
  ],
  providers: [provideHttpClient(withInterceptorsFromDi())],
})
export class MemberPortalSharedModule {}
